import React, { useEffect, useState, useRef, useMemo, useCallback } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import TableContainer from "./creditNoteListContainer"
import Select from "react-select"
import { API_URL } from "helpers/url_helper"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import {
  getBillingRegisterList,
  getServiceRequests,
  deleteBillingRegister,
  sendEmailToCustomer,
  downloadInvoice,
  getBillingCreditNoteList,
  deleteCreditNote,
} from "store/actions"
import LargeModal from "./EmailModal/emailModal"
import JobListGlobalFilter from "./GlobalSearchFilter"
import { sendCreditNoteViaWhatsapp } from "helpers/fakebackend_helper"
import Swal from "sweetalert2"

const CreditNoteList = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Replace useHistory with useNavigate

  const query = new URLSearchParams(location.search);
  const initialPageIndex = parseInt(query.get('pageIndex')) || 0;

  // Handle page changes
  const handlePageChange = useCallback((newPageIndex) => {
    const newQuery = new URLSearchParams(location.search);
    newQuery.set('pageIndex', newPageIndex);
    navigate({ search: newQuery.toString() }, { replace: true });
    console.log("handlePageChange")
  }, [location.search, navigate]);
  
  const [modal_large, setmodal_large] = useState(false)
  const [modalLarge, setModalLarge] = useState(false)
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("authUser")))

  const toggleModalLarge = () => setModalLarge(!modalLarge)
  const [permission, setPermission] = useState(
    JSON.parse(localStorage.getItem("permission"))
  )
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_large() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }
  const [isLoading, setLoading] = useState(false)

  document.title = "Credit Note List"

  const dispatch = useDispatch()
  const billingRegisterState = state => state.billing.creditNoteList.data

  const billingRegisterList = useSelector(billingRegisterState) || []

  useEffect(() => {
    if (user) {
      const value = {
        user_id: user.user_id,
      }
      dispatch(getBillingCreditNoteList(value))
    }
  }, [user])

  const [customerId, setCustomerID] = useState()
  const [bill, setBillNo] = useState()
  const [billData, setBillData] = useState()
  const sendMailModal = (value, credit_note_no, billingData) => {
    setCustomerID(value)
    setBillNo(credit_note_no)
    setBillData(billingData)
    toggleModalLarge()
    // dispatch(sendEmailToCustomer(value))
  }
  const sendMail = value => {
    dispatch(sendEmailToCustomer(value))
  }
  const handleDownloadInvoice = billingId => {
    // Construct the URL for download
    const downloadUrl = `${API_URL}/api/download-credit-note-pdf/${billingId}`

    // Create an anchor element
    const anchorElement = document.createElement("a")
    anchorElement.href = downloadUrl
    anchorElement.target = "_blank" // Open in a new tab
    anchorElement.download = "creditNote.pdf" // Optional: specify a filename for the downloaded file

    // Append the anchor element to the document body (required in some browsers)
    document.body.appendChild(anchorElement)

    // Trigger a click event on the anchor element
    anchorElement.click()

    // Clean up: remove the anchor element from the document body
    document.body.removeChild(anchorElement)
  }

    const sendWhatsappMsg = async (id, name, number) => {
      const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
      const data = {
        client_name: name,
        phone_no: number
      }
      try {
        const response = await sendCreditNoteViaWhatsapp(id, data)
        if (response && response.status === true) {
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Credit Note was sent to the customer via WhatsApp successfully.",
          })
        } else {
          loadingSwal.close()
          Swal.fire({
            title: "failure",
            icon: "error",
            text: "Credit Note could not be sent to the customer via WhatsApp.",
          })
        }
      } catch (error) {
        loadingSwal.close()
        console.error("Error:", error)
        Swal.fire({
          title: "Error",
          icon: "error",
          text:
            error.response.data.message ||
            "An error occurred while saving your work.",
        })
      }
      
    }

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "srNo",
        sortBy: true,
        // filterable: false,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {/* <Link className="text-dark" to="#">#00001</Link> */}
                <Link className="text-dark" to="#">
                  {" "}
                  {cellProps.row.index + 1}
                </Link>
              </h5>
            </>
          )
        },
      },

      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Credit </span>
            <span style={{ display: "block" }}>Note No</span>
          </div>
        ),
        accessor: "credit_note_no",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link
                  className="text-dark"
                  // to={`/service-request/view-service/${cellProps.row.original.id}`}
                >
                  {cellProps.row.original.credit_note_no}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Credit </span>
            <span style={{ display: "block" }}>Note Date</span>
          </div>
        ),
        accessor: "credit_note_date",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.credit_note_date}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Original</span>
            <span style={{ display: "block" }}> Invoice no</span>
          </div>
        ),
        accessor: "bill_no",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.bill_no}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Original </span>
            <span style={{ display: "block" }}>Inv Date</span>
          </div>
        ),
        accessor: "bill_date",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.bill_date}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Billing</span>
            <span style={{ display: "block" }}>Company</span>
          </div>
        ),
        accessor: "company_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.company_name}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Project</span>
            <span style={{ display: "block" }}>Name</span>
          </div>
        ),
        accessor: "project_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.project_name}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Customer</span>
            <span style={{ display: "block" }}>Name</span>
          </div>
        ),
        accessor: "customer_name",

        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.customer_name}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Credit </span>
            <span style={{ display: "block" }}>Amount</span>
          </div>
        ),
        accessor: "all_total",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.all_total}
                </Link>
              </h5>
            </>
          )
        },
      },

      {
        Header: (
          <div style={{ whiteSpace: "nowrap" }}>
            <span style={{ display: "block" }}>Financial</span>
            <span style={{ display: "block" }}>Year</span>
          </div>
        ),
        accessor: "financial_year",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link className="text-dark">
                  {cellProps.row.original.financial_year}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        filterable: true,
        Cell: cellProps => {
          const handleActionChange = event => {
            const selectedAction = event.target.value

            // Perform any necessary actions based on the selected value
            if (selectedAction === "Edit") {
              navigate(
                `/billing/edit-credit-note/${cellProps.row.original.credit_id}`
              )
            } else if (selectedAction === "Delete") {
              onClickDelete(cellProps.row.original.credit_id)
            } else if (selectedAction === "Record Payment") {
              navigate(
                `/billing/record-payment/${cellProps.row.original.credit_id}`
              )
            } else if (selectedAction === "Send Email to Customer") {
              sendMailModal(
                cellProps.row.original.credit_id,
                cellProps.row.original.credit_note_no,
                cellProps.row.original
              )
            } else if (selectedAction === "Send via WhatsApp") {
              sendWhatsappMsg(
                cellProps.row.original.credit_id,
                cellProps.row.original.customer_name,
                cellProps.row.original.mobile_no
              )
            } else if (selectedAction === "Audit Trail") {
              // Handle Audit Trail action
            } else if (selectedAction === "Download Credit Invoice") {
              handleDownloadInvoice(cellProps.row.original.credit_id)
            } else if (selectedAction === "Preview") {
              navigate(
                `/billing/preview-credit/${cellProps.row.original.credit_id}`
              )
            }
            event.target.value = "Action"
          }
          return (
            <div>
              <select
                className="form-select"
                name="action"
                defaultValue="Action"
                onChange={handleActionChange}
              >
                <option disabled value="Action">
                  Action
                </option>
                {permission
                  .filter(
                    item =>
                      item.page === "/edit-credit-note/:id" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Edit</option>
                  ))}

                {permission
                  .filter(
                    item => item.page === "delete-bill" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Delete</option>
                  ))}

                {permission
                  .filter(
                    item =>
                      item.page === "credit-note-send-email" &&
                      item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Send Email to Customer</option>
                  ))}
                {permission
                  .filter(
                    item =>
                      item.page === "credit-note-download-invoice" &&
                      item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Download Credit Invoice</option>
                  ))}
                {permission
                  .filter(
                    item =>
                      item.page === "/preview-invoice/:id" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Preview</option>
                  ))}
                  {permission
                  .filter(
                    item =>
                      item.page === "credit-note-send-whatsapp" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Send via WhatsApp</option>
                  ))}
              </select>
            </div>
          )
        },
      },
    ],
    []
  )

  const handleUserClick = arg => {
    const user = arg
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState()

  const onClickDelete = users => {
    setDeleteId({ id: users })
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (deleteId && deleteId.id) {
      dispatch(deleteCreditNote(deleteId.id))
    }
    onPaginationPageChange(1)
    setDeleteModal(false)
    if (user) {
      const value = {
        user_id: user.user_id,
      }
      dispatch(getBillingCreditNoteList(value))
    }
    if (user) {
      const value = {
        user_id: user.user_id,
      }
      dispatch(getBillingCreditNoteList(value))
    }
  }

  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }

  const [selectedStatus, setselectedStatus] = useState(null)
  function handleSelectGroup(selectedStatus) {
    setselectedStatus(selectedStatus)
  }
  const keyField = "id"

  return (
    <React.Fragment>
      <LargeModal
        isOpen={modalLarge}
        toggle={toggleModalLarge}
        customerId={customerId}
        bill={bill}
        data={billData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            to="/projects"
            title="Billing"
            breadcrumbItem="Credit Note List"
          />

          <Row>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      initialPageIndex={initialPageIndex}
                      onPageChange={handlePageChange}
                      isPagination={true}
                      columns={columns}
                      data={billingRegisterList}
                      isGlobalFilter={true}
                      isShowingPageLength={true}
                      isAddUserList={true}
                      iscustomPageSizeOptions={true}
                      handleUserClick={handleUserClicks}
                      customPageSize={10}
                      tableClass="table align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationDiv="col-sm-12 col-md-7"
                      pagination="pagination pagination-rounded justify-content-end mt-4"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreditNoteList
